import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import {
  componentRohsProgressShowsBadge,
  resolveComponentRohsProgressStatus,
  type ComponentRohsProgressInput,
  type ComponentRohsProgressStatus,
} from '@/shared/briefing/componentRohsProgress'

function progressBadgeVariant(
  status: ComponentRohsProgressStatus
): 'secondary' | 'warning' | 'success' {
  if (status === 'completed') {
    return 'success'
  }
  if (status === 'inProgress') {
    return 'warning'
  }
  return 'secondary'
}

type V2ComponentRohsProgressBadgeProps = ComponentRohsProgressInput

export function V2ComponentRohsProgressBadge({
  rohsFile,
}: V2ComponentRohsProgressBadgeProps) {
  const { t } = useTranslation('common')
  const status = resolveComponentRohsProgressStatus({ rohsFile })

  if (!componentRohsProgressShowsBadge(status)) {
    return null
  }

  return (
    <Badge variant={progressBadgeVariant(status)}>
      {t(`v2.pages.components.rohsProgress.${status}`)}
    </Badge>
  )
}
